export const COMMENT_SEND_VARIANT = "text";

export const COMMENT_SEND_STYLE = Object.freeze({
  textVariantFontColor: "branded",
  textVariantHoverFontColor: "branded",
  textVariantFontWeight: "dark",
});

export const COMMENT_INPUT_STYLE = Object.freeze({
  mentionColor: "branded",
  borderColor: "light",
});
